import './LoadingSpinner.css'

interface SkeletonProps {
  width?: string
  height?: string
}

function Skeleton({ height, width }: SkeletonProps) {
  return <div className='skeleton-loader' style={{ height: height, width: width }}></div>
}

export default Skeleton
